function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeedLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 24,
    viewBox: "0 0 131 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 24H16C18.1217 24 20.1566 23.1571 21.6569 21.6569C23.1571 20.1566 24 18.1217 24 16H8C5.87827 16 3.84344 16.8429 2.34315 18.3431C0.842855 19.8434 0 21.8783 0 24Z",
    fill: "url(#paint0_linear_27_26)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8H16C18.1217 8 20.1566 7.15715 21.6569 5.65685C23.1571 4.15656 24 2.12173 24 0H8C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8Z",
    fill: "url(#paint1_linear_27_26)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 16H8C5.87827 16 3.84344 15.1571 2.34315 13.6569C0.842855 12.1566 0 10.1217 0 8H16C18.1217 8 20.1566 8.84285 21.6569 10.3431C23.1571 11.8434 24 13.8783 24 16Z",
    fill: "url(#paint2_linear_27_26)",
    style: {}
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32 15.712H40.096C40.4373 17.4827 41.8347 18.368 44.288 18.368C46.912 18.368 48.224 17.8027 48.224 16.672C48.224 16.3307 48.0533 16.0533 47.712 15.84C47.392 15.6267 46.8267 15.456 46.016 15.328L41.888 14.688C38.7307 14.1973 36.3947 13.344 34.88 12.128C33.3653 10.912 32.608 9.30133 32.608 7.296C32.608 5.01334 33.6533 3.232 35.744 1.952C37.8347 0.650667 40.7147 0 44.384 0C51.3173 0 55.0933 2.4 55.712 7.2L47.872 7.872C47.5947 7.06133 47.1573 6.48533 46.56 6.144C45.984 5.80267 45.152 5.632 44.064 5.632C42.976 5.632 42.1333 5.76 41.536 6.016C40.96 6.25067 40.672 6.60267 40.672 7.072C40.672 7.41333 40.8 7.66933 41.056 7.84C41.312 8.01067 41.8133 8.16 42.56 8.288L47.744 9.152C50.8373 9.664 53.0453 10.4747 54.368 11.584C55.712 12.6933 56.384 14.2933 56.384 16.384C56.384 21.4613 52.3413 24 44.256 24C36.576 24 32.4907 21.2373 32 15.712Z",
    fill: "#2C303B",
    style: {
      fill: "#2C303B",
      fill: "color(display-p3 0.1725 0.1882 0.2314)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0372 0.576H78.7092V6.432H66.1012V8.992H78.0692V14.816H66.1012V17.568H79.5092L78.8372 23.424H58.0372V0.576Z",
    fill: "#2C303B",
    style: {
      fill: "#2C303B",
      fill: "color(display-p3 0.1725 0.1882 0.2314)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5622 0.576H102.234V6.432H89.6262V8.992H101.594V14.816H89.6262V17.568H103.034L102.362 23.424H81.5622V0.576Z",
    fill: "#2C303B",
    style: {
      fill: "#2C303B",
      fill: "color(display-p3 0.1725 0.1882 0.2314)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.087 0.576H116.287C125.887 0.576 130.687 4.384 130.687 12C130.687 15.6053 129.439 18.4107 126.943 20.416C124.447 22.4213 120.874 23.424 116.223 23.424H105.087V0.576ZM116.383 16.992C120.33 16.992 122.303 15.3067 122.303 11.936C122.303 8.65067 120.362 7.008 116.479 7.008H113.215V16.992H116.383Z",
    fill: "#2C303B",
    style: {
      fill: "#2C303B",
      fill: "color(display-p3 0.1725 0.1882 0.2314)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27_26",
    x1: -6.0464e-7,
    y1: 24,
    x2: 6.38923,
    y2: 31.3366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9E4D5",
    style: {
      stopColor: "#C9E4D5",
      stopColor: "color(display-p3 0.7882 0.8941 0.8353)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78BB96",
    style: {
      stopColor: "#78BB96",
      stopColor: "color(display-p3 0.4706 0.7333 0.5873)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_27_26",
    x1: -5.45233e-7,
    y1: 7.4,
    x2: 4.75628,
    y2: 15.4169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9E4D5",
    style: {
      stopColor: "#C9E4D5",
      stopColor: "color(display-p3 0.7882 0.8941 0.8353)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78BB96",
    style: {
      stopColor: "#78BB96",
      stopColor: "color(display-p3 0.4706 0.7333 0.5873)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_27_26",
    x1: 3,
    y1: 8.46667,
    x2: 3.2451,
    y2: 15.9883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9E4D5",
    style: {
      stopColor: "#C9E4D5",
      stopColor: "color(display-p3 0.7882 0.8941 0.8353)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78BB96",
    style: {
      stopColor: "#78BB96",
      stopColor: "color(display-p3 0.4706 0.7333 0.5873)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_26"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeedLogo);
export default __webpack_public_path__ + "static/media/seed-logo.dc2f48058cb21d7c2ec78eb2489a1228.svg";
export { ForwardRef as ReactComponent };